import { saveCsListView, CsListView } from "../../utils/user_view_prefs";

function sortGrid(th: HTMLTableCellElement): void {
  const table = th.closest("table");
  const tbody = table?.tBodies[0];
  const key = th.dataset.col;
  if (!table || !tbody || !key) return;

  const ascending = th.getAttribute("aria-sort") !== "ascending";
  const numeric = th.dataset.sortType === "number";
  table.querySelectorAll("th[aria-sort]").forEach((other) => other.setAttribute("aria-sort", "none"));
  th.setAttribute("aria-sort", ascending ? "ascending" : "descending");

  const value = (row: HTMLTableRowElement): string =>
    row.querySelector<HTMLElement>(`td[data-col="${key}"]`)?.dataset.sort || "";
  const rows = Array.from(tbody.querySelectorAll<HTMLTableRowElement>("tr.customer-row"));
  rows.sort((a, b) => {
    const diff = numeric ? Number(value(a)) - Number(value(b)) : value(a).localeCompare(value(b), "sv");
    return ascending ? diff : -diff;
  });
  rows.forEach((row) => tbody.appendChild(row));
}

function setColumnHidden(key: string, hidden: boolean): void {
  document.querySelectorAll<HTMLElement>(`[data-cs-grid] [data-col="${key}"]`).forEach((cell) => {
    cell.hidden = hidden;
  });
}

function hiddenColumns(): string[] {
  return Array.from(document.querySelectorAll<HTMLInputElement>("[data-cs-column-toggle]"))
    .filter((input) => !input.checked)
    .map((input) => input.value);
}

// Mockup label: "Hide" when every column shows, otherwise "n hidden" on a green chip.
function syncColumnsMenu(): void {
  const menu = document.querySelector<HTMLElement>("[data-cs-columns]");
  if (!menu) return;

  menu.querySelectorAll<HTMLInputElement>("[data-cs-column-toggle]").forEach((input) => {
    input.closest(".dd-opt")?.classList.toggle("active", input.checked);
  });
  const count = hiddenColumns().length;
  const label = menu.querySelector("[data-cs-columns-label]");
  if (label) label.textContent = count ? `${count} hidden` : "Hide";
  menu.querySelector(".dd-trigger")?.classList.toggle("has-val", count > 0);
}

function setDensity(density: string): void {
  const list = document.querySelector<HTMLElement>("[data-cs-list]");
  if (!list) return;

  list.classList.remove("cs-density-compact", "cs-density-comfortable");
  list.classList.add(`cs-density-${density}`);
  document.querySelectorAll<HTMLElement>("[data-cs-density]").forEach((button) => {
    const active = button.dataset.csDensity === density;
    button.classList.toggle("active", active);
    button.setAttribute("aria-pressed", String(active));
  });
}

export function bindCsListGrid(): void {
  document.addEventListener("click", (e) => {
    const target = e.target as HTMLElement;

    const sort = target.closest<HTMLElement>("[data-cs-sort]");
    if (sort) {
      const th = sort.closest("th");
      if (th) sortGrid(th);
      return;
    }

    if (target.closest("[data-cs-columns-show-all]")) {
      document.querySelectorAll<HTMLInputElement>("[data-cs-column-toggle]").forEach((input) => {
        input.checked = true;
        setColumnHidden(input.value, false);
      });
      syncColumnsMenu();
      saveCsListView({ hidden: [] });
      return;
    }

    const density = target.closest<HTMLElement>("[data-cs-density]");
    if (density?.dataset.csDensity) {
      setDensity(density.dataset.csDensity);
      saveCsListView({ density: density.dataset.csDensity as CsListView["density"] });
    }
  });

  document.addEventListener("change", (e) => {
    const input = e.target as HTMLInputElement;
    if (!input.matches("[data-cs-column-toggle]")) return;

    setColumnHidden(input.value, !input.checked);
    syncColumnsMenu();
    saveCsListView({ hidden: hiddenColumns() });
  });
}
